import React from 'react';

const GraphIcon = () => (
  <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.66667 12.5V7.35714H5.16667M14.5 12.5H0.5M5.16667 12.5V3.92857H9.25M9.25 12.5V0.5H13.3333V12.5"
      stroke="#007AAE"
      stroke-opacity="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default GraphIcon;
